<ng-container *ngIf="showAddNewAddressForm">
  <div class="mb-checkout-new-shipping-address-form">
    <form [formGroup]="shippingAddressForm">

      <div class="row mb-4">
        <div class="col-sm-12 col-md-9 text-left mb-checkout-headline"
             data-cy="mb-checkout-enter-new-shipping-address-label">
          {{ 'address.pleaseEnterYourShippingAddress' | cxTranslate }}
        </div>
        <div class="col-sm-12 col-md-3 mt-3 mt-md-0 text-md-right mb-checkout-mandatory-text" data-cy="mb-form-shipping-address-mandatory-text">{{ 'mbcommon.mandatory' | cxTranslate }}</div>
      </div>

      <mb-checkout-base-form-partial [address]="shippingAddress"
                                     [formGroup]="shippingAddressForm"
                                     [companyLabelKey]="'address.us.companyUniversity'"
                                     [instituteLabelKey]="'address.us.institute'"
                                     [departmentLabelKey]="'address.us.departmentDivision'"
                                     [buildingLabelKey]="(isNotMobile$ | async) ? 'address.us.additionalShippingInformation' : 'address.us.buildingFloorRoom'"
                                     [labLabelKey]="'address.us.labGroupPI'"
                                     [displayShippingLabel]="true">
      </mb-checkout-base-form-partial>

      <mb-checkout-location-form-partial [address]="shippingAddress"
                                         [formGroup]="shippingAddressForm"
                                         [streetInformationLabelKey]="'address.us.street'">
      </mb-checkout-location-form-partial>

      <mb-checkout-city-form-partial [address]="shippingAddress"
                                     [formGroup]="shippingAddressForm"
                                     [cityLabelKey]="'address.us.city'">
      </mb-checkout-city-form-partial>

      <mb-checkout-state-form-partial [address]="shippingAddress"
                                      [formGroup]="shippingAddressForm"
                                      [regions]="regions"
                                      [selectedRegion]="selectedRegion">
      </mb-checkout-state-form-partial>

      <mb-checkout-zip-code-form-partial [address]="shippingAddress"
                                         [formGroup]="shippingAddressForm"
                                         [zipCodeLabelKey]="'address.us.zipCode'">
      </mb-checkout-zip-code-form-partial>

      <mb-checkout-country-form-partial [address]="shippingAddress"
                                        [formGroup]="shippingAddressForm"
                                        [isCountryDisabled]="isCountryDisabled()">
      </mb-checkout-country-form-partial>

      <div class="row no-gutters mt-4">
        <div class="col-12 col-lg mr-4 mt-2 order-2 order-lg-1">
          <button class="btn btn-block btn-secondary mb-buttons"
                  data-cy="mb-checkout-shipping-address-back-btn"
                  type="button"
                  (click)="cancelAddNewAddressForm()">
            {{ (!displaySimpleButtons ? 'navigationPage.backBtn' : 'navigationPage.cancelBtn') | cxTranslate }}
          </button>
        </div>
        <div class="col-12 col-lg mt-2 order-1 order-lg-2">
          <button
            data-cy="mb-checkout-shipping-address-next-btn"
            class="btn btn-block btn-primary mb-buttons"
            type="button"
            mbOneClickAllowed
            (click)="saveAndContinue()">
            {{ (!displaySimpleButtons ? 'navigationPage.nextBtn' : 'navigationPage.saveAndContinueBtn') | cxTranslate }}
          </button>
        </div>
      </div>
    </form>
  </div>
</ng-container>
